import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Ginger Pot",
    tagline: "Slow-simmered chicken porridge",
    description: "Ginger Pot serves silky chicken porridge made from a broth we simmer overnight. See the menu and order ahead for pickup.",
    url: getOrigin(),
    locale: 'en-US',
    currency: 'USD',
    phone: '(503) 555-0142',
    phoneHref: 'tel:+15035550142',
    address: {
        street: "214 Alder Street",
        city: "Portland",
        region: 'OR',
        postalCode: '97204',
        country: 'US'
    }
}

export const navLinks = [
    { label: "Menu", href: '/#menu' },
    { label: "How it's made", href: '/#how-its-made' },
    { label: "Reviews", href: '/#reviews' },
    { label: "Visit", href: '/#visit' },
    { label: "FAQ", href: '/#faq' }
]

export const freeToppings = [
    "Ginger threads",
    "Scallions",
    "Crispy shallots",
    "White pepper",
    "Soy sauce",
    "Chili oil",
    "Cilantro"
]

export const fullAddress = `${siteConfig.address.street}, ${siteConfig.address.city}, ${siteConfig.address.region} ${siteConfig.address.postalCode}`

export const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${siteConfig.name}, ${fullAddress}`)}`
